// src/components/Cards/CardConfiguration/CardConfigCategoryDetalles/CardConfigCategoryDetalles.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../../../config/config.js";

import "./CardConfigCategoryDetalles.css";

// toast
import { toast } from "react-hot-toast";

const CardConfigCategoryDetalles = () => {
  const [tarjetasAmarillas, setTarjetasAmarillas] = useState(2);
  const [acumulables, setAcumulables] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const getConfigTarjeta = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/getconfigtarjetas`, {
          idevent: 194,
          idsport: 5,
        });
        console.log("response config tarjetas", response.data);

        setTarjetasAmarillas(response.data.nro_amarillas_para_roja);
        setAcumulables(response.data.isAcumulableNextFase);
        if (response.data.state === 2) {
          setDisabled(true);
        }
      } catch (error) {
        console.error("Error fetching config tarjetas", error);
      }
    };
    getConfigTarjeta();
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.patch(`${API_BASE_URL}/updateconfigtarjetas`, {
        idevent: 194,
        idsport: 5,
        nro_amarillas_para_roja: tarjetasAmarillas,
        isAcumulableNextFase: acumulables,
      });
      toast.success("¡Configuración Guardada Exitosamente!");
    } catch (error) {
      toast.error("¡Error al Guardar la Configuración!");
      console.error("Error updating config tarjetas", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = async () => {
    try {
      await axios.patch(`${API_BASE_URL}/updateconfigtarjetas`, {
        idevent: 194,
        idsport: 5,
        state: 2,
      });
      toast.success("¡Configuración Cerrada Exitosamente!");
      setDisabled(true);
    } catch (error) {
      toast.error("¡Error al Cerrar la Configuración!");
      console.error("Error al cerrar la Config Category", error);
    }
  };

  return (
    <div className="flex justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-2xl w-full">
        <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">
          Configuración de Tarjetas
        </h2>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">
            Tarjetas Amarillas Necesarias para Generar Roja
          </label>
          <div className="flex items-center">
            <input
              type="range"
              min="0"
              max="5"
              value={tarjetasAmarillas}
              onChange={(e) => setTarjetasAmarillas(e.target.value)}
              className="w-full cursor-pointer"
              disabled={disabled}
            />
            <span className="ml-3 text-gray-800 font-semibold">
              {tarjetasAmarillas}
            </span>
          </div>
        </div>

        <div className="mb-6 flex items-center justify-between">
          <label className="text-gray-700 font-medium">
            Tarjetas amarillas acumulables para la siguiente fase
          </label>
          <input
            type="checkbox"
            checked={acumulables}
            onChange={(e) => setAcumulables(e.target.checked)}
            className="toggle-checkbox"
            disabled={disabled}
          />
        </div>

        <div className="flex justify-between">
          <button
            className={`px-4 py-2 rounded ${
              disabled
                ? "bg-blue-500 opacity-50 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            } text-white`}
            onClick={handleSave}
            disabled={loading || disabled}
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
          <button
            className={`px-4 py-2 rounded ${
              disabled
                ? "bg-red-500 opacity-50 cursor-not-allowed"
                : "bg-red-500 hover:bg-red-600"
            } text-white`}
            onClick={handleClose}
            disabled={disabled}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardConfigCategoryDetalles;
